// extracted by mini-css-extract-plugin
module.exports = {"ldsDefault":"Loader_ldsDefault__2w6Ly"};